import MonochromeLogo from './MonochromeLogo';
export default MonochromeLogo;
